import React, { useContext } from 'react';
import moment from 'moment';
import { Cell, CopyCell, DeleteCell, EditCell, LinkCell } from '../../../../generic/AsTable/Standard';
import { tableCellStyle } from '../../../CampaignBrief/CampaignBriefStyles';
import { SystemSettingsContext } from '../../../../../contexts/SystemSettingsContext';

const DataRow = ({
    entity = {},
    index,
    scrollPx,
    onHover,
    isHighlighted,
    rowHeight,
    visibleRows,
    readOnly,
    hideEditable = false,
    onEdit,
    onDelete,
    onLinkClick,
    displayField,
    colWidths = [100, 100, 100]
}) => {
    const { formatCurrency, formatNumber } = useContext(SystemSettingsContext);
    /**
     * mouseEnter event handler for all cells in this row
     * used for row highlighting and dragging
     * @param {Event} event - event
     */
    const onMouseEnter = (event) => {
        typeof onHover === 'function' && onHover(index);
    };

    /**
     * mouseLeave event handler for all cells in this row
     * @param {Event} event - event
     */
    const onMouseLeave = (event) => typeof onHover === 'function' && onHover(-1);

    const handleEditClick = () => {
        onEdit(entity);
    };

    const handleDeleteClick = () => {
        onDelete(index);
    };

    const handleLinkClick = () => {
        onLinkClick(index);
    };
    const roundedImpacts = (v) => {
        return formatNumber(v, { maximumFractionDigits: 0 });
    };
    const value1 = () => {
        let fld = 'bookedImpacts';
        switch (displayField) {
            case 'Impacts':
                fld = 'bookedImpacts';
                break;
            case 'Spots':
                fld = 'bookedSpots';
                break;
            case 'Budget':
                fld = 'bookedPrice';
                break;
        }
        return entity[fld];
    };
    const value2 = () => {
        let fld = 'bookedImpacts';
        switch (displayField) {
            case 'Impacts':
                fld = 'deliveredImpacts';
                break;
            case 'Spots':
                fld = 'deliveredSpots';
                break;
            case 'Budget':
                fld = 'deliveredPrice';
                break;
        }
        return entity[fld];
    };
    const value3 = () => {
        let fld = 'bookedImpacts';
        switch (displayField) {
            case 'Impacts':
                fld = 'scheduledImpacts';
                break;
            case 'Spots':
                fld = 'scheduledSpots';
                break;
            case 'Budget':
                fld = 'scheduledPrice';
                break;
        }
        return entity[fld];
    };
    return (
        <div style={{ display: 'flex' }}>
            <Cell
                area={`timeSlot${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={{
                    ...tableCellStyle,
                    paddingLeft: 12,
                    fontSize: 14,
                    justifyContent: 'flex-start',
                    borderWidth: '0 1px 1px 1px',
                    width: colWidths[0]
                }}
            >
                {entity?.name}
            </Cell>
            <Cell
                area={`delivered${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={{
                    ...tableCellStyle,
                    paddingRight: 18, // ASSP-7703 right-align numbers
                    justifyContent: 'flex-end',
                    width: colWidths[1]
                }}
            >
                {roundedImpacts(value1())}
            </Cell>
            <Cell
                area={`booked${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={{
                    ...tableCellStyle, 
                    paddingRight: 18, // ASSP-7703 right-align numbers
                    justifyContent: 'flex-end',
                    width: colWidths[1]
                }}
            >
                {roundedImpacts(value2())}
            </Cell>
            <Cell
                area={`scheduled${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={{
                    ...tableCellStyle, 
                    paddingRight: 18, // ASSP-7703 right-align numbers
                    justifyContent: 'flex-end',
                    width: colWidths[1]
                }}
            >
                {roundedImpacts(value3())}
            </Cell>
            <Cell
                area={`tracking${index}`}
                rowHeight={rowHeight}
                scrollPx={scrollPx}
                index={index}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                isHighlighted={isHighlighted}
                visibleRows={visibleRows}
                style={{
                    ...tableCellStyle, 
                    paddingRight: 18, // ASSP-7703 right-align numbers
                    justifyContent: 'flex-end',
                    width: colWidths[2] // ASSP-7703 [2] was [1], updated for scrollbar
                }}
            >
                {value1() ? roundedImpacts((value3() / value1()) * 100) + ' %' : ''}
            </Cell>
        </div>
    );
};

export default DataRow;
